module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-body"
  }, [(!_vm.telaProjeto) ? _c('legend', {
    staticStyle: {
      "background-color": "#fcfcfc"
    }
  }, [_vm._v("\n     Cadastro de Licenças\n ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loading.show),
      expression: "loading.show"
    }],
    staticClass: "overlay",
    staticStyle: {
      "position": "absolute",
      "top": "0px",
      "left": "0px",
      "width": "100%",
      "height": "100%",
      "display": "none",
      "background": "rgba(255, 255, 255, 0.7)",
      "z-index": "1000"
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh fa-spin",
    staticStyle: {
      "top": "50%",
      "left": "50%",
      "position": "absolute",
      "font-size": "30px"
    }
  })]), _vm._v(" "), (!_vm.editarLicencas) ? _c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "primary"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(true)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-pencil",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n    Detalhar/Editar Cadastro de Licenças ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('g-button-ujarak', {
    staticClass: "botao-editar-publico",
    attrs: {
      "color": "warning"
    },
    nativeOn: {
      "click": function($event) {
        return _vm.toggleEdicao(false)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-close",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("\n      Cancelar ")]) : _vm._e(), _vm._v(" "), (_vm.editarLicencas) ? _c('cadastroLicencas', {
    attrs: {
      "idProposta": _vm.idProposta,
      "fecharAnalise": _vm.fecharLicencas
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.editarLicencas) ? _c('b-container', {
    staticClass: "w-100 table-container",
    attrs: {
      "fluid": ""
    }
  }, [_c('b-table', {
    attrs: {
      "show-empty": "",
      "stacked": "md",
      "striped": "",
      "bordered": _vm.table.bordered,
      "items": _vm.table.items,
      "hover": _vm.table.hover,
      "fields": _vm.table.fields,
      "filter": _vm.table.filter,
      "current-page": _vm.table.currentPage,
      "per-page": _vm.table.perPage,
      "sort-by": _vm.table.sortBy,
      "sort-desc": _vm.table.sortDesc,
      "empty-text": "Nenhum registro encontrado"
    },
    on: {
      "update:sortBy": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sort-by": function($event) {
        return _vm.$set(_vm.table, "sortBy", $event)
      },
      "update:sortDesc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      },
      "update:sort-desc": function($event) {
        return _vm.$set(_vm.table, "sortDesc", $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "prazo_apresentacao",
      fn: function(row) {
        return [_vm._v("\n             " + _vm._s(row.value == '' ? '-' : _vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")]
      }
    }, {
      key: "data_apresentacao",
      fn: function(row) {
        return [(row.value == '') ? _c('div', [_c('b', [_vm._v("Não Apresentado")])]) : _c('div', [_vm._v("\n                 " + _vm._s(_vm.moment.utc(row.value).format('DD/MM/YYYY')) + "\n             ")])]
      }
    }, {
      key: "status",
      fn: function(row) {
        return [_c('span', {
          class: _vm.statusClass(row.value)
        }, [_vm._v("\n                 " + _vm._s(row.value) + "\n             ")])]
      }
    }, {
      key: "tipo_licenca",
      fn: function(row) {
        return [_vm._v("\n                 " + _vm._s(row.value.replace('_', ' ')) + "\n             ")]
      }
    }, {
      key: "actions",
      fn: function(row) {
        return [(_vm.usuarioLogado.userType === 'FUNDACAO' && !_vm.todasLicencas) ? _c('b-button', {
          staticClass: "btn btn-danger btn-sm btn-flat",
          attrs: {
            "type": "button",
            "data-cy": "exclui-licenca-procedimento"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.confirmaExclusao('Atenção, este procedimento não poderá ser desfeito. Confirma Exclusão?', function () { return _vm.preparaExclusao(row.item); })
            }
          }
        }, [_c('i', {
          staticClass: "fa fa-trash",
          attrs: {
            "aria-hidden": "true"
          }
        }), _vm._v(" Excluir")]) : _vm._e()]
      }
    }], null, false, 2664264219)
  }), _vm._v(" "), _c('div', {
    staticClass: "row-flex all-end w-100"
  }, [_vm._v("\n             (" + _vm._s(_vm.table.items.length) + ") Licenças Encontradas\n         ")]), _vm._v(" "), _c('b-row', [_c('b-col', {
    staticClass: "my-1",
    attrs: {
      "md": "12",
      "right": ""
    }
  }, [_c('b-pagination', {
    attrs: {
      "total-rows": _vm.table.items.length,
      "per-page": _vm.table.perPage
    },
    model: {
      value: (_vm.table.currentPage),
      callback: function($$v) {
        _vm.$set(_vm.table, "currentPage", $$v)
      },
      expression: "table.currentPage"
    }
  })], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-b5641088!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/licenciamentoAmbiental/licenciamentoAmbientalAnalise.vue
// module id = 2063
// module chunks = 1